import { ReactNode, useEffect } from 'react';
import { useAuthStore } from '@shared/store/authStore';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  // New authStore doesn't need initialization - API client is created immediately
  return <>{children}</>;
}